import { BottomSheet, Spiner, Typography } from '@/ui-kit'
import styles from './lang-selector.module.scss'
import { useState } from 'react'
import { useGetAvailableLangs } from '@/hooks/use-get-available-langs'
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@/assets/icons'
import { useUpdateUserData } from '@/hooks/use-update-profile'
import { CountryFlag } from '../country-flag/country-flag'
import clsx from 'clsx'
import { loadLangTranslations, SELECTED_LANG } from '@/utils/translations'
import { useAuth } from '@/store/useAuth'

interface Props {
    className?: string
}

export const LangSelector: React.FC<Props> = ({ className }) => {
    const [isEditLangModalOpen, setIsEditLangModalOpen] = useState(false)
    const { data: langsRes } = useGetAvailableLangs()
    const { t, i18n } = useTranslation();
    const { mutateAsync: updateUserData } = useUpdateUserData();

    const userData = useAuth(state => state.getUser())

    const handleLangSelect = (lang: string) => {
        if (userData) updateUserData({ lang })
        loadLangTranslations(lang)
        localStorage.setItem(SELECTED_LANG, lang)
    }

    return (
        <>
            <div className={clsx(styles.langSelector, className)} onClick={() => setIsEditLangModalOpen(true)}>
                <CountryFlag lang={i18n.language} className={styles.langSelectorIcon} />
                <Typography fontWeight="medium">{i18n.language.toUpperCase()}</Typography>
            </div>
            <BottomSheet
                overlayClassName={styles.bottomsheetOverlay}
                contentClassName={styles.langBottomsheetContent}
                isOpen={isEditLangModalOpen}
                isDeskorTop={false}
                className={styles.langBottomsheet}
                onClose={() => setIsEditLangModalOpen(false)}>
                <div className={styles.editNameModalContent}>
                    <div className={styles.editNameModalContentHeader}>
                        <Typography
                            className={styles.editNameModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'semibold'}>
                            {t('select_lang')}
                        </Typography>
                    </div>
                    {
                        langsRes?.data ?
                            (
                                <ul className={styles.editLangModalContent}>
                                    {
                                        langsRes.data.map(lang => (
                                            <li className={styles.editLangModalContentItem} onClick={() => handleLangSelect(lang.name)}>
                                                <div className={styles.editLangModalContentItemMain}>
                                                    <CountryFlag
                                                        lang={lang.name}
                                                        className={styles.editLangModalContentItemIcon} />
                                                    <Typography className={styles.editLangModalContentItemLabel}>
                                                        {lang.autonym}
                                                    </Typography>
                                                </div>
                                                {
                                                    i18n.language === lang.name &&
                                                    <CheckIcon
                                                        className={styles.editLangModalContentItemCheckmark}
                                                        width={20}
                                                        height={20} />
                                                }
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        : <Spiner className={styles.langBottomsheetContentLoader} /> 
                    }
                </div>
            </BottomSheet>
        </>
    )
}
